import { render, staticRenderFns } from "./asset-group-category-asset-group-view.vue?vue&type=template&id=0e87876d"
import script from "./asset-group-category-asset-group-view.vue?vue&type=script&lang=js"
export * from "./asset-group-category-asset-group-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports